import { render, staticRenderFns } from "./multi-category-dialog.vue?vue&type=template&id=58e45488&scoped=true"
import script from "./multi-category-dialog.vue?vue&type=script&lang=js"
export * from "./multi-category-dialog.vue?vue&type=script&lang=js"
import style0 from "./multi-category-dialog.vue?vue&type=style&index=0&id=58e45488&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e45488",
  null
  
)

export default component.exports